angular.module('mychart').directive('apImmunizationsCard',
    [
        function () {
            'use strict';

            function link($scope) {
                function getRoutineDoses(routineDoses, length) {
                    if (routineDoses > length)
                        return new Array(routineDoses - length);
                    else {
                        return [];
                    }
                }

                function rowSpanCal(routineDoses, vaccineCount) {
                    return (routineDoses > vaccineCount) ? routineDoses : vaccineCount;
                }

                $scope.getRoutineDoses = getRoutineDoses;
                $scope.rowSpanCal = rowSpanCal;
            }

            return {
                restrict: 'EA',
                templateUrl: '/mychart/views/directives/apImmunizationsCard.html',
                scope: {
                    patientImmunizations: '=patientImmunizations'
                },
                link: link
            };
        }]);